import styled from 'styled-components';

import { Button } from 'src/UIComponents';

const Flexer = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
`;

export const Container = styled(Flexer)`
  gap: ${({ theme }) => theme.spacing.md};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const SuperQuicks = styled(Flexer)`
  gap: ${({ theme }) => theme.spacing.sm};
`;
export const Quicks = styled(Flexer)`
  gap: ${({ theme }) => theme.spacing.sm};
  align-items: center;
`;

export const IconButton = styled(Button)`
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.sm};
  font-size: 12px;
  border-radius: 0.5em;

  > svg {
    width: 24px;
    height: 24px;
    pointer-events: none; // https://stackoverflow.com/a/29814882/5401263
  }
`;
